import { Link } from 'react-router-dom'

import Icon from '../../ui/Icon'

export type ErrorPageProps = {
  code: number
  message: string
  title: string
  highlightedTitle?: string
  description: string
  actionLabel: string
  actionTo?: string
}

export const ErrorPage = ({
  code,
  message,
  title,
  highlightedTitle,
  description,
  actionLabel,
  actionTo = '/',
}: ErrorPageProps) => (
  <main className="error-page container-fluid">
    <div className="row align-items-center g-5 error-page-row">
      <div className="col-12 col-lg-5 error-page-content">
        <div className="eyebrow error-page-status">
          {code} - {message}
        </div>
        <h1 className="display error-page-title">
          {title}
          {highlightedTitle && (
            <>
              {' '}
              <span className="error-page-title-highlight">
                {highlightedTitle}
              </span>
            </>
          )}
        </h1>
        <p className="error-page-description">{description}</p>
        <Link
          to={actionTo}
          className="btn btn-primary btn-lg error-page-back-btn"
        >
          {actionLabel}
          <Icon name="arrowR" size={16} />
        </Link>
      </div>

      <div className="col-12 col-lg-7" aria-hidden="true">
        <div className="error-page-court">
          <div className="error-page-court-graphic">
            <svg viewBox="0 0 360 480" className="court-diagram">
              <rect x="40" y="40" width="280" height="400" />
              <line x1="40" y1="160" x2="320" y2="160" />
              <line x1="40" y1="320" x2="320" y2="320" />
              <line x1="180" y1="160" x2="180" y2="320" />
              <line x1="40" y1="240" x2="320" y2="240" className="court-net" />
              <circle cx="345" cy="400" r="7" className="court-ball" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </main>
)
